export default __webpack_public_path__ + "static/media/memsql.16f192cd.svg";